import { useState } from "react";
import StepPassword from "./StepPassword/StepPassword";
import ForgotMyPassword from "./ForgotMyPassword/ForgotMyPassword";

export default function LoginStepPassword({
  segment,
  cpfCnpj,
  email,
  cpfAccess,
}) {
  const [step, setStep] = useState("login");

  return (
    <>
      {step === "login" && (
        <StepPassword
          segment={segment}
          cpfCnpj={cpfCnpj}
          onForgot={() => setStep("forgot")}
          cpfAccess={cpfAccess}
        />
      )}
      {step === "forgot" && (
        <ForgotMyPassword
          segment={segment}
          cpfCnpj={cpfCnpj}
          email={email}
          cpfAccess={cpfAccess}
          onBack={() => setStep("login")}
        />
      )}
    </>
  );
}
